import {Text} from 'common/text'
import {Grid} from '@mui/material'
import styled from 'styled-components'
import React, {useContext} from 'react'
import {ProductContext} from "../../../provider/~context";
import {Radio} from "../../../../../common/form/radio";
import {ProductTab} from "./tabAllProduct";
import {CategoryType} from "./tabCategory";
import {sendRequestAuth} from "../../../../../api/api";
import config from "../../../../../config";
import {useCategoryAction, useProductAction} from "../../../provider/~reducer";
import {useParams} from "react-router-dom";

const ConfigProduct = () => {

   const {pageState, pageDispatch} = useContext(ProductContext)
   const {configProductType} = pageState.formCreate

   return (
      <StyledInfoBasic>
         <Grid container spacing={2} style={{marginBottom: 16}}>
            <Grid xs={3} sm={3} md={3} lg={3} item className={'flex product-info-basic'}>
               <Radio checked={configProductType?.value === 'all'} disabled={configProductType?.value !== 'all'}/>
               <Text style={{marginLeft: 8}}>Bán tất cả sản phẩm</Text>
            </Grid>
            <Grid xs={3} sm={3} md={3} lg={3} item className={'flex product-info-basic'}>
               <Radio checked={configProductType?.value === 'category'} disabled={configProductType?.value !== 'category'}/>
               <Text style={{marginLeft: 8}}>Theo danh mục</Text>
            </Grid>
            <Grid xs={3} sm={3} md={3} lg={3} item className={'flex product-info-basic'}>
               <Radio checked={configProductType?.value === 'product'} disabled={configProductType?.value !== 'product'}/>
               <Text style={{marginLeft: 8}}>Theo sản phẩm</Text>
            </Grid>
         </Grid>
         {
            configProductType?.value === 'category' && <CategoryType/>
         }
         {
            configProductType?.value === 'product' && <ProductTab/>
         }
      </StyledInfoBasic>
   )
}

export default ConfigProduct

export const StyledInfoBasic = styled.div`
  padding-top: 16px;
  .product-info-basic {
    cursor: pointer;
  }
`
